/* tslint:disable */
/* eslint-disable */
/**
 * Datenbankgestalter.de API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  ApplicationScope,
  CustomerShort,
  Message,
  Organisation,
  PaymentType,
} from '../models';
import {
    ApplicationScopeFromJSON,
    ApplicationScopeToJSON,
    CustomerShortFromJSON,
    CustomerShortToJSON,
    MessageFromJSON,
    MessageToJSON,
    OrganisationFromJSON,
    OrganisationToJSON,
    PaymentTypeFromJSON,
    PaymentTypeToJSON,
} from '../models';

export interface AddMessageForOrganisationByIdRequest {
    xApplicationScope: ApplicationScope;
    id: string;
    message: Message;
}

export interface CreateOrganisationRequest {
    xApplicationScope: ApplicationScope;
    organisation: Organisation;
}

export interface DeleteOrganisationRequest {
    xApplicationScope: ApplicationScope;
    id: string;
}

export interface GetAllOrganisationsRequest {
    xApplicationScope: ApplicationScope;
}

export interface GetCurrentOrganisationRequest {
    xApplicationScope: ApplicationScope;
}

export interface GetCurrentOrganisationCustomersRequest {
    xApplicationScope: ApplicationScope;
}

export interface GetMessagesForCurrentOrganisationRequest {
    xApplicationScope: ApplicationScope;
}

export interface GetMessagesForOrganisationByIdRequest {
    xApplicationScope: ApplicationScope;
    id: string;
}

export interface GetOrganisationRequest {
    xApplicationScope: ApplicationScope;
    id: string;
}

export interface GetOrganisationCustomersRequest {
    xApplicationScope: ApplicationScope;
    id: string;
}

export interface SetReadOnlyForOrganisationRequest {
    xApplicationScope: ApplicationScope;
    id: string;
    readOnly: boolean;
}

export interface UpdateCurrentOrganisationRequest {
    xApplicationScope: ApplicationScope;
    organisation: Organisation;
}

export interface UpdateOrganisationRequest {
    xApplicationScope: ApplicationScope;
    id: string;
    organisation: Organisation;
}

export interface UpdateOrganisationPaymentMethodsRequest {
    xApplicationScope: ApplicationScope;
    id: string;
    acceptedPaymentMethods: Array<PaymentType>;
}

/**
 * 
 */
export class OrganisationControllerApi extends runtime.BaseAPI {

    /**
     * add message for organisation by id
     * add message for organisation by id
     */
    async addMessageForOrganisationByIdRaw(requestParameters: AddMessageForOrganisationByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Message>> {
        if (requestParameters.xApplicationScope === null || requestParameters.xApplicationScope === undefined) {
            throw new runtime.RequiredError('xApplicationScope','Required parameter requestParameters.xApplicationScope was null or undefined when calling addMessageForOrganisationById.');
        }

        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling addMessageForOrganisationById.');
        }

        if (requestParameters.message === null || requestParameters.message === undefined) {
            throw new runtime.RequiredError('message','Required parameter requestParameters.message was null or undefined when calling addMessageForOrganisationById.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters.xApplicationScope !== undefined && requestParameters.xApplicationScope !== null) {
            headerParameters['X-Application-Scope'] = String(requestParameters.xApplicationScope);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/organisations/{id}/messages`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: MessageToJSON(requestParameters.message),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => MessageFromJSON(jsonValue));
    }

    /**
     * add message for organisation by id
     * add message for organisation by id
     */
    async addMessageForOrganisationById(requestParameters: AddMessageForOrganisationByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Message> {
        const response = await this.addMessageForOrganisationByIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * create an organisation
     * create an organisation
     */
    async createOrganisationRaw(requestParameters: CreateOrganisationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Organisation>> {
        if (requestParameters.xApplicationScope === null || requestParameters.xApplicationScope === undefined) {
            throw new runtime.RequiredError('xApplicationScope','Required parameter requestParameters.xApplicationScope was null or undefined when calling createOrganisation.');
        }

        if (requestParameters.organisation === null || requestParameters.organisation === undefined) {
            throw new runtime.RequiredError('organisation','Required parameter requestParameters.organisation was null or undefined when calling createOrganisation.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters.xApplicationScope !== undefined && requestParameters.xApplicationScope !== null) {
            headerParameters['X-Application-Scope'] = String(requestParameters.xApplicationScope);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/organisations`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: OrganisationToJSON(requestParameters.organisation),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => OrganisationFromJSON(jsonValue));
    }

    /**
     * create an organisation
     * create an organisation
     */
    async createOrganisation(requestParameters: CreateOrganisationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Organisation> {
        const response = await this.createOrganisationRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * delete an organisation
     * delete an organisation
     */
    async deleteOrganisationRaw(requestParameters: DeleteOrganisationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.xApplicationScope === null || requestParameters.xApplicationScope === undefined) {
            throw new runtime.RequiredError('xApplicationScope','Required parameter requestParameters.xApplicationScope was null or undefined when calling deleteOrganisation.');
        }

        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling deleteOrganisation.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters.xApplicationScope !== undefined && requestParameters.xApplicationScope !== null) {
            headerParameters['X-Application-Scope'] = String(requestParameters.xApplicationScope);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/organisations/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * delete an organisation
     * delete an organisation
     */
    async deleteOrganisation(requestParameters: DeleteOrganisationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deleteOrganisationRaw(requestParameters, initOverrides);
    }

    /**
     * get all organisations
     * get all organisations
     */
    async getAllOrganisationsRaw(requestParameters: GetAllOrganisationsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<Organisation>>> {
        if (requestParameters.xApplicationScope === null || requestParameters.xApplicationScope === undefined) {
            throw new runtime.RequiredError('xApplicationScope','Required parameter requestParameters.xApplicationScope was null or undefined when calling getAllOrganisations.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters.xApplicationScope !== undefined && requestParameters.xApplicationScope !== null) {
            headerParameters['X-Application-Scope'] = String(requestParameters.xApplicationScope);
        }

        const response = await this.request({
            path: `/organisations`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(OrganisationFromJSON));
    }

    /**
     * get all organisations
     * get all organisations
     */
    async getAllOrganisations(requestParameters: GetAllOrganisationsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<Organisation>> {
        const response = await this.getAllOrganisationsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * get current organisation
     * get current organisation
     */
    async getCurrentOrganisationRaw(requestParameters: GetCurrentOrganisationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Organisation>> {
        if (requestParameters.xApplicationScope === null || requestParameters.xApplicationScope === undefined) {
            throw new runtime.RequiredError('xApplicationScope','Required parameter requestParameters.xApplicationScope was null or undefined when calling getCurrentOrganisation.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters.xApplicationScope !== undefined && requestParameters.xApplicationScope !== null) {
            headerParameters['X-Application-Scope'] = String(requestParameters.xApplicationScope);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/organisations/current`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => OrganisationFromJSON(jsonValue));
    }

    /**
     * get current organisation
     * get current organisation
     */
    async getCurrentOrganisation(requestParameters: GetCurrentOrganisationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Organisation> {
        const response = await this.getCurrentOrganisationRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * get customers of current organisation
     * get customers of current organisation
     */
    async getCurrentOrganisationCustomersRaw(requestParameters: GetCurrentOrganisationCustomersRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<CustomerShort>>> {
        if (requestParameters.xApplicationScope === null || requestParameters.xApplicationScope === undefined) {
            throw new runtime.RequiredError('xApplicationScope','Required parameter requestParameters.xApplicationScope was null or undefined when calling getCurrentOrganisationCustomers.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters.xApplicationScope !== undefined && requestParameters.xApplicationScope !== null) {
            headerParameters['X-Application-Scope'] = String(requestParameters.xApplicationScope);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/organisations/current/customers`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(CustomerShortFromJSON));
    }

    /**
     * get customers of current organisation
     * get customers of current organisation
     */
    async getCurrentOrganisationCustomers(requestParameters: GetCurrentOrganisationCustomersRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<CustomerShort>> {
        const response = await this.getCurrentOrganisationCustomersRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * get messages for current organisation
     * get messages for current organisation
     */
    async getMessagesForCurrentOrganisationRaw(requestParameters: GetMessagesForCurrentOrganisationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<Message>>> {
        if (requestParameters.xApplicationScope === null || requestParameters.xApplicationScope === undefined) {
            throw new runtime.RequiredError('xApplicationScope','Required parameter requestParameters.xApplicationScope was null or undefined when calling getMessagesForCurrentOrganisation.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters.xApplicationScope !== undefined && requestParameters.xApplicationScope !== null) {
            headerParameters['X-Application-Scope'] = String(requestParameters.xApplicationScope);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/organisations/current/messages`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(MessageFromJSON));
    }

    /**
     * get messages for current organisation
     * get messages for current organisation
     */
    async getMessagesForCurrentOrganisation(requestParameters: GetMessagesForCurrentOrganisationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<Message>> {
        const response = await this.getMessagesForCurrentOrganisationRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * get messages for organisation by ID
     * get messages for organisation by ID
     */
    async getMessagesForOrganisationByIdRaw(requestParameters: GetMessagesForOrganisationByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<Message>>> {
        if (requestParameters.xApplicationScope === null || requestParameters.xApplicationScope === undefined) {
            throw new runtime.RequiredError('xApplicationScope','Required parameter requestParameters.xApplicationScope was null or undefined when calling getMessagesForOrganisationById.');
        }

        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling getMessagesForOrganisationById.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters.xApplicationScope !== undefined && requestParameters.xApplicationScope !== null) {
            headerParameters['X-Application-Scope'] = String(requestParameters.xApplicationScope);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/organisations/{id}/messages`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(MessageFromJSON));
    }

    /**
     * get messages for organisation by ID
     * get messages for organisation by ID
     */
    async getMessagesForOrganisationById(requestParameters: GetMessagesForOrganisationByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<Message>> {
        const response = await this.getMessagesForOrganisationByIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * get an organisation
     * get an organisation
     */
    async getOrganisationRaw(requestParameters: GetOrganisationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Organisation>> {
        if (requestParameters.xApplicationScope === null || requestParameters.xApplicationScope === undefined) {
            throw new runtime.RequiredError('xApplicationScope','Required parameter requestParameters.xApplicationScope was null or undefined when calling getOrganisation.');
        }

        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling getOrganisation.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters.xApplicationScope !== undefined && requestParameters.xApplicationScope !== null) {
            headerParameters['X-Application-Scope'] = String(requestParameters.xApplicationScope);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/organisations/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => OrganisationFromJSON(jsonValue));
    }

    /**
     * get an organisation
     * get an organisation
     */
    async getOrganisation(requestParameters: GetOrganisationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Organisation> {
        const response = await this.getOrganisationRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * get customers of an organisation
     * get customers of an organisation
     */
    async getOrganisationCustomersRaw(requestParameters: GetOrganisationCustomersRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<CustomerShort>>> {
        if (requestParameters.xApplicationScope === null || requestParameters.xApplicationScope === undefined) {
            throw new runtime.RequiredError('xApplicationScope','Required parameter requestParameters.xApplicationScope was null or undefined when calling getOrganisationCustomers.');
        }

        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling getOrganisationCustomers.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters.xApplicationScope !== undefined && requestParameters.xApplicationScope !== null) {
            headerParameters['X-Application-Scope'] = String(requestParameters.xApplicationScope);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/organisations/{id}/customers`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(CustomerShortFromJSON));
    }

    /**
     * get customers of an organisation
     * get customers of an organisation
     */
    async getOrganisationCustomers(requestParameters: GetOrganisationCustomersRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<CustomerShort>> {
        const response = await this.getOrganisationCustomersRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * set read only for organisation
     * set read only for organisation
     */
    async setReadOnlyForOrganisationRaw(requestParameters: SetReadOnlyForOrganisationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.xApplicationScope === null || requestParameters.xApplicationScope === undefined) {
            throw new runtime.RequiredError('xApplicationScope','Required parameter requestParameters.xApplicationScope was null or undefined when calling setReadOnlyForOrganisation.');
        }

        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling setReadOnlyForOrganisation.');
        }

        if (requestParameters.readOnly === null || requestParameters.readOnly === undefined) {
            throw new runtime.RequiredError('readOnly','Required parameter requestParameters.readOnly was null or undefined when calling setReadOnlyForOrganisation.');
        }

        const queryParameters: any = {};

        if (requestParameters.readOnly !== undefined) {
            queryParameters['readOnly'] = requestParameters.readOnly;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters.xApplicationScope !== undefined && requestParameters.xApplicationScope !== null) {
            headerParameters['X-Application-Scope'] = String(requestParameters.xApplicationScope);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/organisations/{id}/read-only`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * set read only for organisation
     * set read only for organisation
     */
    async setReadOnlyForOrganisation(requestParameters: SetReadOnlyForOrganisationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.setReadOnlyForOrganisationRaw(requestParameters, initOverrides);
    }

    /**
     * update current organisation
     * update current organisation
     */
    async updateCurrentOrganisationRaw(requestParameters: UpdateCurrentOrganisationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Organisation>> {
        if (requestParameters.xApplicationScope === null || requestParameters.xApplicationScope === undefined) {
            throw new runtime.RequiredError('xApplicationScope','Required parameter requestParameters.xApplicationScope was null or undefined when calling updateCurrentOrganisation.');
        }

        if (requestParameters.organisation === null || requestParameters.organisation === undefined) {
            throw new runtime.RequiredError('organisation','Required parameter requestParameters.organisation was null or undefined when calling updateCurrentOrganisation.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters.xApplicationScope !== undefined && requestParameters.xApplicationScope !== null) {
            headerParameters['X-Application-Scope'] = String(requestParameters.xApplicationScope);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/organisations/current`,
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: OrganisationToJSON(requestParameters.organisation),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => OrganisationFromJSON(jsonValue));
    }

    /**
     * update current organisation
     * update current organisation
     */
    async updateCurrentOrganisation(requestParameters: UpdateCurrentOrganisationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Organisation> {
        const response = await this.updateCurrentOrganisationRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * update an organisation
     * update an organisation
     */
    async updateOrganisationRaw(requestParameters: UpdateOrganisationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Organisation>> {
        if (requestParameters.xApplicationScope === null || requestParameters.xApplicationScope === undefined) {
            throw new runtime.RequiredError('xApplicationScope','Required parameter requestParameters.xApplicationScope was null or undefined when calling updateOrganisation.');
        }

        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling updateOrganisation.');
        }

        if (requestParameters.organisation === null || requestParameters.organisation === undefined) {
            throw new runtime.RequiredError('organisation','Required parameter requestParameters.organisation was null or undefined when calling updateOrganisation.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters.xApplicationScope !== undefined && requestParameters.xApplicationScope !== null) {
            headerParameters['X-Application-Scope'] = String(requestParameters.xApplicationScope);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/organisations/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: OrganisationToJSON(requestParameters.organisation),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => OrganisationFromJSON(jsonValue));
    }

    /**
     * update an organisation
     * update an organisation
     */
    async updateOrganisation(requestParameters: UpdateOrganisationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Organisation> {
        const response = await this.updateOrganisationRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * update organisation payment methods
     * update organisation payment methods
     */
    async updateOrganisationPaymentMethodsRaw(requestParameters: UpdateOrganisationPaymentMethodsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Organisation>> {
        if (requestParameters.xApplicationScope === null || requestParameters.xApplicationScope === undefined) {
            throw new runtime.RequiredError('xApplicationScope','Required parameter requestParameters.xApplicationScope was null or undefined when calling updateOrganisationPaymentMethods.');
        }

        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling updateOrganisationPaymentMethods.');
        }

        if (requestParameters.acceptedPaymentMethods === null || requestParameters.acceptedPaymentMethods === undefined) {
            throw new runtime.RequiredError('acceptedPaymentMethods','Required parameter requestParameters.acceptedPaymentMethods was null or undefined when calling updateOrganisationPaymentMethods.');
        }

        const queryParameters: any = {};

        if (requestParameters.acceptedPaymentMethods) {
            queryParameters['acceptedPaymentMethods'] = requestParameters.acceptedPaymentMethods;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters.xApplicationScope !== undefined && requestParameters.xApplicationScope !== null) {
            headerParameters['X-Application-Scope'] = String(requestParameters.xApplicationScope);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/organisations/{id}/accepted-payment-methods`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => OrganisationFromJSON(jsonValue));
    }

    /**
     * update organisation payment methods
     * update organisation payment methods
     */
    async updateOrganisationPaymentMethods(requestParameters: UpdateOrganisationPaymentMethodsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Organisation> {
        const response = await this.updateOrganisationPaymentMethodsRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
